onComplete(function () {
	const sectionTriggers = gsap.utils.toArray(".navbar-white-trigger");
	sectionTriggers.forEach((trigger) => {
		gsap.to('.nav-header', {
			duration: 0,
			scrollTrigger: {
				trigger: trigger,
				start: `top ${document.querySelector('.nav-header').clientHeight * .75}`,
				end: `bottom ${document.querySelector('.nav-header').clientHeight * .75}`,
				onToggle: () => {
					document.querySelector('.nav-header').classList.contains('navbar-white') ? document.querySelector('.nav-header').classList.remove('navbar-white') : document.querySelector('.nav-header').classList.add('navbar-white');
				}
			}
		})
	})

	if (document.querySelector('.fit-view')) {
		const colors = ['#578d1d', '#345610', '#b4ce61', '#8ba046', '#EC6426'];
		document.querySelectorAll('.fit-view .content-item-preview').forEach(preview => {
			preview.addEventListener('mouseover', () => {
				const random = Math.floor(Math.random() * colors.length);
				preview.querySelector('.image img').style.borderColor = colors[random];
			})
		})
	}

	document.querySelector('header .navbar-toggler').addEventListener('click', () => {
		if (document.querySelector('.nav-header').classList.contains('open')) {
			gsap.to('.navbar-overlay .nav-title, .navbar-overlay .nav-languages a', {
				y: 32,
				opacity: 0
			});
			document.querySelector('.nav-header').classList.remove('open')
		} else {
			gsap.to('.navbar-overlay .nav-title, .navbar-overlay .nav-languages a', {
				y: 0,
				opacity: 1,
				stagger: .05,
				duration: .25,
				ease: "power2.out",
				delay: 0.15
			});
			document.querySelector('.nav-header').classList.add('open')
		}
	})
});